import { useState, useEffect, useRef } from "react";
import { usePosicionDesplegable } from "../posicionDesplegable";
import Icon from "../Icon";
import { mapaColoresEtapas, etapaES } from "../../utils";
import { clicable } from "../ClicableTeclado.jsx";

// Desplegable de etapa con el color de cada estado.
//
// Un <select> nativo no vale: el color de las <option> lo pinta cada navegador
// a su manera —Safari las ignora y en Windows salen sobre fondo del sistema—,
// así que el estado se distinguía solo por el texto. Este va pintado por JS y
// se ve igual en todos, con el mismo codigo de color que el tablero.
//
// Sirve tambien de filtro: con `todas` añade la opción de no filtrar por etapa.
export default function SelectorEtapa({ etapas = [], valor, onChange, disabled,
                                        todas = null, ancho = null }) {
  const [abierto, setAbierto] = useState(false);
  const caja = useRef(null);
  const panelRef = useRef(null);
  const { estilo: posicion } = usePosicionDesplegable(abierto, caja, panelRef, { separacion: 5 });

  useEffect(() => {
    if (!abierto) return;
    const fuera = e => { if (caja.current && !caja.current.contains(e.target)) setAbierto(false); };
    document.addEventListener("mousedown", fuera);
    return () => document.removeEventListener("mousedown", fuera);
  }, [abierto]);

  const nombreDe = e => etapaES(e.name ?? e.nombre);
  const colores = mapaColoresEtapas(etapas);
  const actual = etapas.find(e => String(e.id) === String(valor));
  const col = actual ? colores[actual.id] : "var(--text3)";

  const elegir = id => { setAbierto(false); onChange(id); };

  return (
    <div ref={caja} style={{ position:"relative", minWidth:0 }}>
      <button className="btn" disabled={disabled} onClick={() => setAbierto(p => !p)}
        style={{ display:"flex", alignItems:"center", gap:6, width: ancho || undefined,
                 padding:"6px 10px", borderRadius:20, fontSize:11.5, fontWeight:700,
                 fontFamily:"var(--font)", cursor: disabled ? "not-allowed" : "pointer",
                 border:`1px solid ${actual ? `${col}66` : "var(--border-ctl)"}`,
                 background: actual ? `${col}1a` : "var(--surface)",
                 color: actual ? col : "var(--text2)" }}>
        {actual && <span style={{ width:8, height:8, borderRadius:"50%", background:col, flexShrink:0 }}/>}
        <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
          {actual ? nombreDe(actual) : (todas || "—")}
        </span>
        <Icon name="chevron-down" size={10} color={actual ? col : "var(--text3)"}
          style={{ marginLeft:"auto" }}/>
      </button>

      {abierto && (
        <div ref={panelRef} style={{ zIndex:20, minWidth:190,
                      background:"var(--surface)", border:"1px solid var(--border)", borderRadius:11,
                      boxShadow:"var(--shadow-lg)", overflow:"hidden", padding:4, ...posicion }}>
          {todas && (
            <div {...clicable(() => elegir(""))}
              style={{ padding:"7px 10px", borderRadius:8, cursor:"pointer", fontSize:12,
                       color:"var(--text3)", background: valor ? "transparent" : "var(--bg)" }}
              onMouseEnter={e => e.currentTarget.style.background = "var(--bg)"}
              onMouseLeave={e => e.currentTarget.style.background = valor ? "transparent" : "var(--bg)"}>
              {todas}
            </div>
          )}
          {etapas.map(e => {
            const c = colores[e.id];
            const sel = String(e.id) === String(valor);
            return (
              <div key={e.id} {...clicable(() => elegir(e.id))}
                style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", borderRadius:8,
                         cursor:"pointer", fontSize:12, fontWeight: sel ? 700 : 500,
                         color: sel ? c : "var(--text)",
                         background: sel ? `${c}1a` : "transparent" }}
                onMouseEnter={ev => ev.currentTarget.style.background = `${c}1a`}
                onMouseLeave={ev => ev.currentTarget.style.background = sel ? `${c}1a` : "transparent"}>
                <span style={{ width:8, height:8, borderRadius:"50%", background:c, flexShrink:0 }}/>
                {nombreDe(e)}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
